import md5 from "md5";
import React from "react";
import Cookies from "universal-cookie";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
function CerrarSesion() {
  const cookie = new Cookies();

  const cerrarSecion = () => {
    cookie.remove("id", { path: "/" });
    cookie.remove("Nombre", { path: "/" });
    cookie.remove("correo", { path: "/" });
    cookie.remove("contrasena", { path: "/" });
    cookie.remove("tipo_Usuario", { path: "/" });
    cookie.remove("institucionid", { path: "/" });
    cookie.remove("Rol", { path: "/" });
    cookie.remove("hash", { path: "/" });
    cookie.remove("hash", { path: "/" });
    cookie.remove("Rol", { path: "/" });
    cookie.remove("usuarioId", { path: "/" });
    window.location.href = "/";
  };
  return (
    <button className="btn btn-secondary" onClick={cerrarSecion}>
      Cerrar Sesion <IoIcons.IoMdPower />
    </button>
  );
}
export default CerrarSesion;
